import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Login from './components/Login';
import UserList from './components/UserList';
import UserForm from './components/UserForm';
import { useAuth } from './context/AuthContext';
import FormList from './components/FormList';
import SubmissionList from './components/SubmissionList';
import DomainList from './components/DomainList';

function App() {
  const { user } = useAuth();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/users" />} />
        <Route
          path="/users"
          element={user ? <UserList /> : <Navigate to="/login" />}
        />
        <Route
          path="/forms"
          element={user ? <FormList /> : <Navigate to="/login" />}
        />
        <Route
          path="/domains/"
          element={user ? <DomainList /> : <Navigate to="/login" />}
        />
        <Route
          path="/submissions"
          element={user ? <SubmissionList /> : <Navigate to="/login" />}
        />
        <Route
          path="/users/add"
          element={user ? <UserForm /> : <Navigate to="/login" />}
        />
        <Route
          path="/users/edit/:id"
          element={user ? <UserForm /> : <Navigate to="/login" />}
        />
        <Route path="*" element={<Navigate to={user ? "/users" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;